import { useQuery } from 'react-query';
import { api } from 'api/api';

export const useGetCollegeLeagues = (isCollegeLeagues) =>
  useQuery({
    queryKey: ['getCollegeLeagues'],
    queryFn: () => api.leagues.getCollegeLeagues(),
    enabled: isCollegeLeagues,
  });
